<ng-container *ngIf="urlsLoading">
	<div class="text-center p-4">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
		<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_LOAD_MSG_URL'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="urlsError">
	<div class="text-center p-4">
		<i class="pi pi-exclamation-triangle text-danger" style="font-size: 2rem"></i>
		<p class="p-error mt-2">{{ translateServ.dictionary['MAINT_LOAD_FAILED_MSG_URL'] }}</p>
	</div>
</ng-container>
<ng-container *ngIf="!urlsLoading && !urlsError">
	<div class="horizontal-scroll">
		<div class="flex justify-between items-center mb-3 px-2">
			<!-- Left: Create New button -->
			<button pButton type="button" icon="pi pi-plus"
				label="{{ translateServ.dictionary['CREATE_NEW'] || 'Create New' }}"
				class="p-button-sm p-button-primary" (click)="createNewRecord()"></button>

			<!-- Right: Global filter -->
			<span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<input type="text" pInputText [(ngModel)]="globalFilter" (input)="applyGlobalFilter()"
					placeholder="{{ translateServ.dictionary['SEARCH'] || 'Search' }}"
					class="p-inputtext-sm" />
			</span>
		</div>
		<p-table 
			#dt 
			id = "tab_urls"
			[globalFilterFields]="globalFilterFields" 
			[value]="urls"
			[totalRecords] = "urls.length"
			dataKey="RecID"
			*ngIf="urls && urls.length > 0; else noUrls" styleClass="app-data-table app-data-table--paged app-data-table--editable p-datatable-sm p-datatable-striped"
			responsiveLayout="scroll" 
			[paginator]="true" 
			[rows]="getCurrentPageSize(0, urls.length)" 
			[rowsPerPageOptions]="setPaginator(urls.length)"
			(onPage) = "onRowsPerPageChange($event,0, urls.length)"
			[showCurrentPageReport]="true"
			currentPageReportTemplate="{{ translateServ.dictionary['TAB_FOOTER_SHOWING'] }} {first} {{ translateServ.dictionary['TAB_FOOTER_TO'] }} {last} {{ translateServ.dictionary['TAB_FOOTER_OF'] }} {totalRecords} {{ translateServ.dictionary['MAINT_TABLE_URLS'] }}"
			[tableStyle]="{'min-width': '68rem', 'table-layout': 'auto'}" [paginatorDropdownAppendTo]="'body'">
			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === urls.length ? 'All' : item.value }}
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="RecID" style="width: 10%;">
						{{ translateServ.dictionary['MAINT_CS_TIT_ID'] || 'ID' }}
						<p-sortIcon field="RecID"></p-sortIcon>
					</th>
					<th pSortableColumn="URL" style="width: 20%;">
						{{ translateServ.dictionary['MAINT_IN_TIT_URL'] || 'URL' }}
						<p-sortIcon field="URL"></p-sortIcon>
					</th>
					<th pSortableColumn="IsActive">
						{{ translateServ.dictionary['STEP_TAB_TIT_ACT_STAT'] || 'Status' }}
						<p-sortIcon field="IsActive"></p-sortIcon>
					</th>
					<th pSortableColumn="IsApproved">
						{{ translateServ.dictionary['STEP_TAB_TIT_APPROVED'] || 'Approved' }}
						<p-sortIcon field="IsApproved"></p-sortIcon>
					</th>
					<th pSortableColumn="Descr">
						{{ translateServ.dictionary['STEP_TAB_TIT_DESC'] || 'Description' }}
						<p-sortIcon field="Descr"></p-sortIcon>
					</th>
					<th pSortableColumn="DateEntered">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_ENTERED'] || 'Created On' }}
						<p-sortIcon field="DateEntered"></p-sortIcon>
					</th>
					<th pSortableColumn="DateUpdated">
						{{ translateServ.dictionary['MAINT_CS_TIT_DATE_UPDATED'] || 'Updated On' }}
						<p-sortIcon field="DateUpdated"></p-sortIcon>
					</th>
					<th>{{ translateServ.dictionary['MAINT_CS_TIT_ACTIONS'] || 'Actions' }}</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-urlItem>
				<tr>
					<td>{{ urlItem.RecID }}</td>
					<td>
						<a [href]="urlItem.Url" target="_blank" rel="noopener noreferrer"
							class="text-blue-400 hover:underline truncate-url" [pTooltip]="urlItem.Url">
							{{ urlItem.Url.length > 25 ? (urlItem.Url | slice:0:25) + '…' : urlItem.Url }}
						</a>
					</td>


					<!-- Status -->
					<td>
						<p-tag
							[value]="urlItem.IsActive === 1 ? (translateServ.dictionary['ACTIVE'] || 'Active') : (translateServ.dictionary['INACTIVE'] || 'Inactive')"
							[severity]="getUrlSeverity(urlItem.IsActive)"
							(click)="toggleUrlStatus(urlItem, true)">
						</p-tag>
					</td>

					<!-- Approved -->
					<td>
						<p-tag
							[value]="urlItem.IsApproved === 1 ? (translateServ.dictionary['APPROVED'] || 'Approved') : (translateServ.dictionary['NOT_APPROVED'] || 'Not Approved')"
							[severity]="urlItem.IsApproved === 1 ? 'success' : 'warning'"
							(click)="toggleUrlStatus(urlItem, false)">
						</p-tag>
					</td>

					<!-- Description with tooltip -->
					<td>
						<span *ngIf="urlItem.Descr; else noDescr" [pTooltip]="urlItem.Descr" tooltipPosition="top">
							{{ urlItem.Descr.length > 20 ? (urlItem.Descr | slice:0:20) + '…' : urlItem.Descr }}
						</span>
						<ng-template #noDescr>
							<span class="text-gray-400">—</span>
						</ng-template>
					</td>

					<!-- Dates -->
					<td>
						{{ urlItem.DateEntered ? (urlItem.DateEntered | date:'mediumDate') : 'N/A' }}
					</td>
					<td>
						{{ urlItem.DateUpdated ? (urlItem.DateUpdated | date:'mediumDate') : 'N/A' }}
					</td>

					<!-- Actions -->
					<td>
						<div class="flex gap-2">
							<button pButton icon="pi pi-pencil" (click)="editUrl(urlItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
							<button pButton icon="pi pi-trash" (click)="confirmDelete(urlItem)"
								class="p-button-rounded p-button-text p-button-sm"
								[pTooltip]="translateServ.dictionary['TOOLTIP_EDIT_USER']" tooltipPosition="top">
							</button>
						</div>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
	<ng-template #noUrls>
		<div class="text-center p-4">
			<i class="pi pi-link text-400" style="font-size: 3rem"></i>
			<p class="text-500 mt-2">{{ translateServ.dictionary['MAINT_NO_DATA_MSG_URL'] }}</p>
		</div>
	</ng-template>
</ng-container>